var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 100,
    y1: 200,
    x2: 100,
    y2: -1.818989e-12
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8F51A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1172BA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M117.1,117.2c1.3,0,2.6-0.6,3.4-1.7c1.4-1.9,1.1-4.6-0.8-6l-15.4-11.6V67.2 c0-2.4-1.9-4.3-4.3-4.3c-2.4,0-4.3,1.9-4.3,4.3v35l18.8,14.2C115.3,116.9,116.2,117.2,117.1,117.2z M195,5c-3-3.2-7.3-5-11.7-5H16.7 C12.3,0,8,1.8,5,5c-3.2,3-5,7.3-5,11.7v166.7c0,4.4,1.8,8.6,5,11.7c3,3.2,7.3,5,11.7,5h166.7c9.1-0.2,16.4-7.6,16.7-16.7V16.7 C200,12.3,198.2,8,195,5z M183.3,183.3H16.7V16.7h166.7V183.3z M100,159.4c15.2,0,30.4-5.8,42-17.4c23.2-23.2,23.2-60.9,0-84.1 C118.9,34.8,81.1,34.8,58,58c-23.2,23.2-23.2,60.9,0,84.1C69.6,153.6,84.8,159.4,100,159.4z M68.2,68.2C77,59.5,88.5,55.1,100,55.1 c11.5,0,23,4.4,31.8,13.1c17.5,17.5,17.5,46,0,63.6c-17.5,17.5-46,17.5-63.6,0C50.7,114.3,50.7,85.7,68.2,68.2z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/timeline.756c6118d6cbf0a4427339b36d02dfff.svg";
export { ForwardRef as ReactComponent };